import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StrategyPlanningPage from './pages/StrategyPlanningPage';
import ProgressTrackingPage from './pages/ProgressTrackingPage';
import RdProjectsPage from './pages/RdProjectsPage';
import GrantsPage from './pages/GrantsPage';
import RiskManagementPage from './pages/RiskManagementPage';
import BusinessPlanningPage from './pages/BusinessPlanningPage';
import AdminSetupPage from './pages/AdminSetupPage';
import UsersPage from './pages/UsersPage';
import PerformanceManagementPage from './pages/PerformanceManagementPage';
import ReportingAnalyticsPage from './pages/ReportingAnalyticsPage';
import CollaborationPage from './pages/CollaborationPage';
import GovernancePage from './pages/GovernancePage';


function ProtectedRoute({ children }) { const { user } = useAuth(); return user ? children : <Navigate to="/login" />; }
function AdminRoute({ children }) { const { user, isAdmin } = useAuth(); if (!user) return <Navigate to="/login" />; if (!isAdmin()) return <Navigate to="/" />; return children; }
function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="strategy" element={<StrategyPlanningPage />} />
         <Route path="business-plans" element={<BusinessPlanningPage />} />
        <Route path="progress" element={<ProgressTrackingPage />} />
        <Route path="performance" element={<PerformanceManagementPage />} />

        <Route path="projects" element={<RdProjectsPage />} />
        <Route path="grants" element={<GrantsPage />} />
        <Route path="risks" element={<RiskManagementPage />} />
       
        <Route path="admin" element={<AdminRoute><AdminSetupPage /></AdminRoute>} />
          <Route path="governance" element={<AdminRoute><GovernancePage /></AdminRoute>} />
        <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
          <Route path="reporting" element={<ReportingAnalyticsPage />} />
          <Route path="collaboration" element={<CollaborationPage />} />
      </Route>
    </Routes>
  );
}
export default function App() { return (<BrowserRouter><AuthProvider><AppRoutes /></AuthProvider></BrowserRouter>); }
